import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useGetProfileInformationQuery } from "../../../Redux/apis/ApiSlice";
import { notification } from "antd";

const ConnectStripe = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const authToken = localStorage.getItem("authToken");
  const [onBoarding, setOnboarding] = useState();
  const [accountId, setAccountId] = useState();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [accountInfo, setAccountInfo] = useState(null);
  const {
    data: profileData,
    error,
    isLoading,
    refetch,
  } = useGetProfileInformationQuery();
  useEffect(() => {
    setOnboarding(profileData?.user?.onBoarding);
    setAccountId(profileData?.user?.accountId);
  }, [profileData]);

  // Fetch connected account info when onboarded
  useEffect(() => {
    if (onBoarding === true) {
      const fetchAccountInfo = async () => {
        try {
          const response = await fetch(
            `${apiUrl}/api/payment/connected-account-info`,
            {
              headers: {
                Authorization: `Bearer ${authToken}`,
              },
            }
          );
          const data = await response.json();
          if (response.ok) {
            setAccountInfo(data);
          }
        } catch (err) {
          // Optionally handle error
        }
      };
      fetchAccountInfo();
    }
  }, [onBoarding, apiUrl, authToken]);

  const handleConnectStripe = async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      const response = await fetch(
        `${apiUrl}/api/payment/create-connected-account`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        if (data.error && data.error.includes('already started')) {
          notification.warning({ message: data.error });
          setErrorMsg(data.error);
          return;
        }
        throw new Error(data.error || data.message || "Failed to connect to Stripe.");
      }
      const { url } = data;
      if (!url) throw new Error("No onboarding URL returned from server.");
      window.open(url, "_blank");
      notification.success({ message: "Stripe onboarding started in a new tab." });
    } catch (err) {
      setErrorMsg(err.message);
      notification.error({ message: err.message });
    } finally {
      setLoading(false);
    }
  };

  let buttonLabel = "Connect Payment Account";
  if (accountId && onBoarding === false) buttonLabel = "Resume Onboarding";
  if (onBoarding === true) buttonLabel = "Reconnect Payment Account";

  let heading = "Connect Your Payment Account";
  if (onBoarding === true) heading = "Your payment account is already connected!";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        padding: 4,
        borderRadius: 2,
        boxShadow: 4,
      }}
    >
      <Typography
        component="h1"
        sx={{
          fontWeight: "bold",
          color: "var(--primary-color)",
          marginBottom: 2,
          fontSize: { xs: "20px", md: "30px" },
        }}
      >
        {heading}
      </Typography>
      {onBoarding === true && accountInfo && (
        <Box sx={{ mb: 2, textAlign: "center" }}>
          <Typography variant="subtitle1">
            <b>Connected Account Name:</b> {accountInfo.displayName || "N/A"}
          </Typography>
          <Typography variant="subtitle2">
            <b>Account ID:</b> {accountInfo.accountId}
          </Typography>
        </Box>
      )}
      <Typography
        variant="body1"
        sx={{
          color: "#6c757d",
          textAlign: "left",
          marginBottom: 3,
        }}
      >
        {onBoarding === true
          ? "Click the button below to re-connect your new payment account."
          : "To manage paid events, you need to connect your account."}
      </Typography>
      {errorMsg && (
        <Typography color="error" sx={{ mb: 2 }}>{errorMsg}</Typography>
      )}
      <Button
        variant={accountId && onBoarding === false ? "outlined" : "contained"}
        color={accountId && onBoarding === false ? "warning" : "primary"}
        onClick={handleConnectStripe}
        disabled={loading}
        sx={{
          backgroundColor: onBoarding === true ? "var(--secondary-color)" : undefined,
          padding: "12px 24px",
          borderRadius: '4px',
          boxShadow: 3,
          fontSize: "14px",
          "&:hover": {
            backgroundColor: "var(--primary-color)",
          },
          mt: 2
        }}
      >
        {buttonLabel}
      </Button>
    </Box>
  );
};

export default ConnectStripe;
